// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3KPvj","label":"styles_label__3PoB0"};